import React from "react";

import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";

type MoreInfoPopoverProps = {
  title: string;
  text: string;
};

function MoreInfoPopover(props: MoreInfoPopoverProps) {
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const [lastOpenedWithClick, setLastOpenedWithClick] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!open) {
      setLastOpenedWithClick(false);
    }
    setOpen(true);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (open && lastOpenedWithClick) {
      setOpen(false);
    } else {
      setLastOpenedWithClick(true);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!lastOpenedWithClick) {
      handleClose();
    }
  };

  return (
    <div>
      <IconButton
        ref={anchorRef}
        onClick={handleClick}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handleMouseLeave}
      >
        <InfoOutlinedIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorRef === null || !open ? null : anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        sx={{
          pointerEvents: lastOpenedWithClick ? undefined : "none",
        }}
      >
        <Box sx={{ padding: 2 }}>
          <Typography variant="h5" color="info.main">
            {props.title}
          </Typography>
          <Typography variant="body1" component="div" color="text.primary">
            <div style={{ whiteSpace: "pre-line" }}>{props.text}</div>
          </Typography>
        </Box>
      </Popover>
    </div>
  );
}

export default MoreInfoPopover;
